// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__yyse-","toggle":"styles_toggle__2v8Qs","preview":"styles_preview__1Rm3d"};